function addLeadingZero(num) {
  return num < 10 ? '0' + num : num;
}

function initCountdown() {
  const counterElement = document.getElementById('christmas-banner-counter');
  if (!counterElement) return;

  const countDownDate = new Date('Jan 01, 2026 07:00:00').getTime();
  let timerId = null;

  function updateTimer() {
    const now = Date.now();
    const distance = countDownDate - now;

    if (distance < 0) {
      clearInterval(timerId);
      counterElement.innerHTML = 'EXPIRED';
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    counterElement.innerHTML = `
      <span>${addLeadingZero(days)}</span>
      <span> : </span>
      <span>${addLeadingZero(hours)}</span>
      <span> : </span>
      <span>${addLeadingZero(minutes)}</span>
      <span> : </span>
      <span>${addLeadingZero(seconds)}</span>
    `;
  }

  updateTimer();
  timerId = setInterval(updateTimer, 1000);
}

function initResponsiveVideo() {
  const christmasVideo = document.getElementById('christmas-video');
  if (!christmasVideo) return;

  let resizeTimeout = null;

  function setVideoSrc() {
    const isMobile = window.innerWidth < 1100;
    const isAlreadyMobile = christmasVideo.classList.contains('mobile');
    const isAlreadyDesktop = christmasVideo.classList.contains('desktop');

    if (isMobile && !isAlreadyMobile) {
      switchVideo('mobile', christmasVideo.dataset.srcmobile);
    }

    if (!isMobile && !isAlreadyDesktop) {
      switchVideo('desktop', christmasVideo.dataset.srcdesktop);
    }
  }

  function switchVideo(type, src) {
    christmasVideo.pause();
    christmasVideo.src = src;
    christmasVideo.load();
    christmasVideo.play();

    christmasVideo.classList.remove('mobile', 'desktop');
    christmasVideo.classList.add(type);
  }

  function resizeThrottler() {
    if (resizeTimeout) return;

    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      setVideoSrc();
    }, 500);
  }

  setVideoSrc();
  window.addEventListener('resize', resizeThrottler);
}

function initLottie() {
  const player = document.getElementById('christmas-lottie-player');
  if (!player) return;

  player.play();
  setInterval(() => {
    player.stop();
    player.play();
  }, 5000);
}

function initChristmasBanner() {
  initCountdown();
  initResponsiveVideo();
  initLottie();
}

document.addEventListener('DOMContentLoaded', initChristmasBanner);
